// Use VNodes rather than HTML so backend/error text stays escaped.
export function notifySupport(vm, message) {
  let notice
  notice = vm.$message({ type: 'warning', duration: 8000, showClose: true,
    message: vm.$createElement('span', [message + ' ', vm.$createElement('el-button', {
      props: { type: 'text' }, on: { click: async () => { if (await vm.openSupport()) notice.close() } }
    }, '联系客服')]) })
}
